var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83268 3.33334H4.49935C3.76297 3.33334 3.16602 3.93029 3.16602 4.66667V12C3.16602 12.7364 3.76297 13.3333 4.49935 13.3333H11.8327C12.5691 13.3333 13.166 12.7364 13.166 12V8.66667M12.2232 2.39052C12.7439 1.86983 13.5881 1.86983 14.1088 2.39052C14.6295 2.91122 14.6295 3.75544 14.1088 4.27614L8.38496 10H6.49935L6.49935 8.11438L12.2232 2.39052Z",
    stroke: "#818586",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/EditProfile.c4ce75471ef14758a7a394505c8875fc.svg";
export { ForwardRef as ReactComponent };